import { PollSlideTypes } from '../../../../../db/types';
import ClassesForm from '../../../../shared/TileClassesForm';
import CoursesForm from '../../../../shared/TileCoursesForm';
import PollsForm from '../../PollsForm';
import Introduction from '../Introduction';
import useBarGraphSteps, { UseBarGraphSteps } from './vm';

export enum Steps {
  INTRODUCTION,
  COURSE_SELECTION,
  CLASS_SELECTION,
  POLL_SELECTION,
}

export interface StepsProps extends UseBarGraphSteps {
  currentStep: Steps;
}

const BarGraphSteps = ({ currentStep, ...vmProps }: StepsProps) => {
  const { goToNextStep } = vmProps;
  const {
    selectedCourse,
    selectedClass,
    handleClickIntroductionNext,
    handleClickCourseSelectionNext,
    handleClickClassSelectionNext,
    handleClickPollSelectionNext,
  } = useBarGraphSteps(vmProps);

  switch (currentStep) {
    case Steps.INTRODUCTION:
      return <Introduction onNext={handleClickIntroductionNext} goToNextStep={goToNextStep} />;
    case Steps.COURSE_SELECTION:
      return <CoursesForm onNext={handleClickCourseSelectionNext} />;
    case Steps.CLASS_SELECTION:
      return <ClassesForm selectedCourse={selectedCourse!} onNext={handleClickClassSelectionNext} />;
    case Steps.POLL_SELECTION:
      return (
        <PollsForm
          selectedCourse={selectedCourse!}
          selectedClass={selectedClass!}
          slideType={PollSlideTypes.BAR_GRAPH}
          onNext={handleClickPollSelectionNext}
        />
      );
    default:
      return null;
  }
};

export default BarGraphSteps;
